// (C) Copyright 2024 Hewlett Packard Enterprise Development LP
import React from 'react'
import { Grommet } from 'grommet'
import { useTranslation } from 'react-i18next'
import { PropTypes } from 'prop-types'
import { Copy } from 'grommet-icons'
import { hpe } from 'grommet-theme-hpe'
import { deepMerge } from 'grommet/utils'

import { FormInput, Button, Tooltip } from '../../../../components'

const theme = deepMerge(hpe, {
  formField: {
    border: {
      color: 'transparent'
    }
  }
})

const TextInputWithCopyButton = ({
  testId,
  label = '',
  value = '',
  copyTextCallback = () => {}
}) => {
  const { t } = useTranslation(['authz'])
  const copyText = () => {
    navigator.clipboard.writeText(value)
    copyTextCallback()
  }
  return (
    <Grommet theme={theme}>
      <FormInput
        action={
          <Button
            testId="copy-btn"
            default
            hoverIndicator="none"
            margin={{ top: 'medium' }}
            onClick={copyText}
            aria-label="Copy to clipboard"
          >
            {({ hover, focus }) => (
              <Tooltip
                dropProps={{ align: { left: 'right' } }}
                info={
                  <>
                    {hover && !focus ? t('copy') : null}
                    {hover && focus ? t('copied') : null}
                  </>
                }
                testId="copy-tooltip"
              >
                <Copy aria-hidden />
              </Tooltip>
            )}
          </Button>
        }
        disabled
        value={value}
        inputType="text"
        label={label}
        name="form-disabled-text-input-with-copy-btn"
        testId={`${testId}-text-field`}
      />
    </Grommet>
  )
}

TextInputWithCopyButton.propTypes = {
  value: PropTypes.string,
  label: PropTypes.string,
  testId: PropTypes.string.isRequired,
  copyTextCallback: PropTypes.func
}

export default TextInputWithCopyButton
